import Vue from 'vue'
export var bus = new Vue()

// common VAR
export var api_dir = "https://pmglab.top/common/api/pcga"

export function goToResultPage(router, type, id) {
    router.push({ path: '/results/' + type + '?id=' + id });
}

export var help_msg = {
    meta: {
        phenotype: {
            "id": "phenotype ID",
            "causaldb_id": 'CAUSALdb ID',
            "category": "category of phenotype",
            "trait": "phenotype name",
            "mesh_term": ' MeSH term of phenotype provided by CAUSALdb',
            "mesh_id": "MeSH ID",
            "sample_size": "sample size of GWAS",
            "n_case": "case number",
            "n_control": "control number",
            "population": "population",
            "pmid": "PubMed ID",
            "doc": "download URL"
        },
        cell: {
            "type": 'reference tissue/cell types dataset ("gtex" represents human tissue dataset, "sc_hs" represents human single cell types, "sc_mm" represents mouse single cell types)',
            "cell_type_id": "tissue/cell type ID",
            "source": "source organ of sample",
            "category_cell_type": "category of inferred cell type",
            "category_source": "category of source organ"
        }
    },
    assocation: {
        phenotype_gene: {
            "phenotype": 'phenotype ID',
            "Gene": "gene symbol",
            "#Var": "variant number in gene",
            "Group": "group ID in conditional step",
            "ECSP": "P-value of ECS",
            "CondiECSP": "conditional P-value",
            "GeneScore": "gene score in conditional step."
        },
        cell_gene: {
            "mean": "Mean of expression value",
            "se": "Standard error of expression value",
            "p": "P-value calculated by REZ",
            "z": "Z-score calculated by REZ"
        }
    }

}

export function uuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
            v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

export function echartTable2vxeTable(res){
    var table_data=[];
    for (var i = 1; i < res.length; i++) {
        var xm={};
        for(var j=0;j<res[0].length;j++){
            xm[res[0][j]]=res[i][j];
        }
        table_data.push(xm);
    }
    return table_data;
}

export function getTime(time_s) {
    if (time_s == -1) {
        return '';
    }
    var date = new Date(time_s * 1000);
    var y = date.getFullYear(),
        m = date.getMonth() + 1,
        d = date.getDate(),
        h = date.getHours(),
        i = date.getMinutes(),
        s = date.getSeconds();
    if (m < 10) { m = '0' + m; }
    if (d < 10) { d = '0' + d; }
    if (h < 10) { h = '0' + h; }
    if (i < 10) { i = '0' + i; }
    if (s < 10) { s = '0' + s; }
    var t = y + '-' + m + '-' + d + ' ' + h + ':' + i + ':' + s;
    return t;
}

function getColorBar(color_number){
    var colors=[];
    for(let i=0;i<color_number;i++){
        colors.push(handleColors(i));
    }
    return colors;
}
function fakeRandom2(seed){
    return ('0.'+Math.sin(seed).toString().substr(6));
}
// 随机生成颜色函数
function handleColors(i){
    let color = '';
    let r=Math.floor(fakeRandom2(i)*256);
    let g=Math.floor(fakeRandom2(i+1)*256);
    let b=Math.floor(fakeRandom2(i+2)*256);
    color = `rgb(${r},${g},${b})`;
    return color;//所有方法的拼接都可以用ES6新特性`其他字符串{$变量名}`替换
}

export function getColors(arr){
    let cate=Array.from(new Set(arr)).sort();
    var ucol=getColorBar(cate.length);
    var cateCol={};
    for(var i=0;i<cate.length;i++){
        cateCol[cate[i]]=ucol[i];
    }
    var colors=[]
    arr.forEach(element => {
        colors.push(cateCol[element])
    });
    return colors
}

var full_expand_icon='path://M149.333333,394.666667c17.066667,0,32-14.933333,32-32v-136.533334l187.733334,187.733334c6.4,6.4,14.933333,8.533333,23.466666,8.533333s17.066667-2.133333,23.466667-8.533333c12.8-12.8,12.8-32,0-44.8l-187.733333-187.733334H362.666667c17.066667,0,32-14.933333,32-32s-14.933333-32-32-32H149.333333c-4.266667,0-8.533333,0-10.666666,2.133334-8.533333,4.266667-14.933333,10.666667-19.2,17.066666-2.133333,4.266667-2.133333,8.533333-2.133334,12.8v213.333334c0,17.066667,14.933333,32,32,32zM874.666667,629.333333c-17.066667,0-32,14.933333-32,32v136.533334L642.133333,597.333333c-12.8-12.8-32-12.8-44.8,0s-12.8,32,0,44.8l200.533334,200.533334H661.333333c-17.066667,0-32,14.933333-32,32s14.933333,32,32,32h213.333334c4.266667,0,8.533333,0,10.666666-2.133334,8.533333-4.266667,14.933333-8.533333,17.066667-17.066666,2.133333-4.266667,2.133333-8.533333,2.133333-10.666667V661.333333c2.133333-17.066667-12.8-32-29.866666-32zM381.866667,595.2l-200.533334,200.533333V661.333333c0-17.066667-14.933333-32-32-32s-32,14.933333-32,32v213.333334c0,4.266667,0,8.533333,2.133334,10.666666,4.266667,8.533333,8.533333,14.933333,17.066666,17.066667,4.266667,2.133333,8.533333,2.133333,10.666667,2.133333h213.333333c17.066667,0,32-14.933333,32-32s-14.933333-32-32-32h-136.533333l200.533333-200.533333c12.8-12.8,12.8-32,0-44.8s-29.866667-10.666667-42.666666,0zM904.533333,138.666667c0-2.133333,0-2.133333,0,0-4.266667-8.533333-10.666667-14.933333-17.066666-17.066667-4.266667-2.133333-8.533333-2.133333-10.666667-2.133333H661.333333c-17.066667,0-32,14.933333-32,32s14.933333,32,32,32h136.533334l-187.733334,187.733333c-12.8,12.8-12.8,32,0,44.8,6.4,6.4,14.933333,8.533333,23.466667,8.533333s17.066667-2.133333,23.466667-8.533333l187.733333-187.733333V362.666667c0,17.066667,14.933333,32,32,32s32-14.933333,32-32V149.333333c-2.133333-4.266667-2.133333-8.533333-4.266667-10.666666z';
var full_mini_icon='path://M313.6,358.4H177.066667c-17.066667,0-32,14.933333-32,32s14.933333,32,32,32h213.333333c4.266667,0,8.533333,0,10.666667-2.133333,8.533333-4.266667,14.933333-8.533333,17.066666-17.066667,2.133333-4.266667,2.133333-8.533333,2.133334-10.666667v-213.333333c0-17.066667-14.933333-32-32-32s-32,14.933333-32,32v136.533333L172.8,125.866667c-12.8-12.8-32-12.8-44.8,0-12.8,12.8-12.8,32,0,44.8l185.6,187.733333zM695.466667,650.666667H832c17.066667,0,32-14.933333,32-32s-14.933333-32-32-32H618.666667c-4.266667,0-8.533333,0-10.666667,2.133333-8.533333,4.266667-14.933333,8.533333-17.066667,17.066667-2.133333,4.266667-2.133333,8.533333-2.133333,10.666666v213.333334c0,17.066667,14.933333,32,32,32s32-14.933333,32-32v-136.533334l200.533333,200.533334c6.4,6.4,14.933333,8.533333,23.466667,8.533333s17.066667-2.133333,23.466667-8.533333c12.8-12.8,12.8-32,0-44.8l-204.8-198.4zM435.2,605.866667c-4.266667-8.533333-8.533333-14.933333-17.066667-17.066667-4.266667-2.133333-8.533333-2.133333-10.666666-2.133333H192c-17.066667,0-32,14.933333-32,32s14.933333,32,32,32h136.533333L128,851.2c-12.8,12.8-12.8,32,0,44.8,6.4,6.4,14.933333,8.533333,23.466667,8.533333s17.066667-2.133333,23.466666-8.533333l200.533334-200.533333V832c0,17.066667,14.933333,32,32,32s32-14.933333,32-32V618.666667c-2.133333-4.266667-2.133333-8.533333-4.266667-12.8zM603.733333,403.2c4.266667,8.533333,8.533333,14.933333,17.066667,17.066667,4.266667,2.133333,8.533333,2.133333,10.666667,2.133333h213.333333c17.066667,0,32-14.933333,32-32s-14.933333-32-32-32h-136.533333L896,170.666667c12.8-12.8,12.8-32,0-44.8-12.8-12.8-32-12.8-44.8,0l-187.733333,187.733333V177.066667c0-17.066667-14.933333-32-32-32s-32,14.933333-32,32v213.333333c2.133333,4.266667,2.133333,8.533333,4.266666,12.8z';
export var full_icons={'expand':full_expand_icon,'mini':full_mini_icon};

const cubic = value => Math.pow(value, 3);
const easeInOutCubic = value => value < 0.5
  ? cubic(value * 2) / 2
  : 1 - cubic((1 - value) * 2) / 2;

export function backTop(){
    const el = document.querySelector('#app');
    el.scrollTop=0;
    // const beginTime = Date.now();
    // const beginValue = el.scrollTop;
    // const rAF = window.requestAnimationFrame || (func => setTimeout(func, 16));
    // const frameFunc = () => {
    //     const progress = (Date.now() - beginTime) / 500;
    //     if (progress < 1) {
    //     el.scrollTop = beginValue * (1 - easeInOutCubic(progress));
    //     rAF(frameFunc);
    //     } else {
    //     el.scrollTop = 0;
    //     }
    // };
    // rAF(frameFunc);
}

import XEUtils, { isNumber } from 'xe-utils'

export function getWord(str){
    str=XEUtils.toString(str);
    if(str.indexOf('</a>')==-1){
        return str.trim();;
    }else{
        var reg = new RegExp('>(.*)</a>','');
        return str.match(reg)[1].trim();
    }
}

export function getLink(str){
    str=XEUtils.toString(str);
    if(str.indexOf('</a>')==-1){
        return false;
    }else{
        var reg = new RegExp('(.*)>.*</a>','');
        return str.match(reg)[1].trim();
    }
}

export var pcga_options_tips={
    'task_label':{'label':'Job label','tip':'Specify a label for your job.'},
    'bulk_cell':{'label':'Tissues (bulk RNA-seq) datasets','tip':'Select bulk cell RNA-seq dataset. Numbers in parentheses indicate the number of tissues or cell types. PCGA firstly estimates asscoaited tissues with bulk cell RNA-seq datasets. Then estimates associated cell types with single cell RNA-seq datasets.'},
    'single_cell':{'label':'Cell types (scRNA-seq) datasets','tip':'Select single cell RNA-seq dataset. Numbers in parentheses indicate the number of tissues or cell types. PCGA firstly estimates asscoaited tissues with bulk cell RNA-seq datasets. Then estimates associated cell types with single cell RNA-seq datasets.'},
    'chr':{'label':'Chromosome column','tip':'Select chromosome column of your uploaded GWAS file. Column names are automatically recognized from the first line of the file you upload.'},
    'bp':{'label':'Base pair position','tip':'Select base pair position column of your uploaded GWAS file. Column names are automatically recognized from the first line of the file you upload.'},
    'p':{'label':'P value column','tip':'Select P value column of your uploaded GWAS file. Column names are automatically recognized from the first line of the file you upload.'},
    'ref':{'label':'Reference genome version','tip':'Select the reference genome version of your GWAS file.'},
    'pop':{'label':'Population','tip':'Select the population of your GWAS. PCGA will use the genotype of the corresponding population in the 1000 Genomes Project to calculate LD (linkage disequilibrium) coefficient for gene-based association analysis.'},
    'multi_test':{'label':'Multiple test correction method','tip':'Select a multiple testing method used to select significant genes for the conditional gene-based analysis.'},
    'fwer':{'label':'Family-wise error rate','tip':'Specify a family-wise error rate cutoff based on the multiple test correction method selected above.'},
    'mhc':{'label':'Exclude MHC region','tip':'Select whether to exclude MHC (major histocompatibility complex) regions when performing gene-based association analysis.'},
    'region':{'label':'Extend size','tip':'Select the extension window size of a gene to cover more potential regulatory variants.'},
    'email':{'label':'Email (optional)','tip':'Input your email address and you will be notified when the job is complete. The job typically run for 30 to 60 minutes.','placeholder':'Input your email address and you will be notified when the job is complete'},     
    'max_gene':{'label':'Max gene number','tip':'Specify max gene number for conditional gene based analysis.'},

    'ref_eqtl':{'label':'Reference eQTL tissue','tip':'Specify a tissue of eQTL summary statistic file from GTEx projects.'},
    'ref_eqtl_type':{'label':'Reference eQTL type','tip':'Specify a type of eQTL summary statistic file from GTEx projects.'},
    'a1':{'label':'Allel 1 (A1) column','tip':'Select A1 column of your uploaded GWAS file.'},
    'a2':{'label':'Allel 2 (A2) column','tip':'Select A2 column of your uploaded GWAS file.'},
    'freq_a1':{'label':'A1 frequence column','tip':'Select A1 frequence column of your uploaded GWAS file.'},
    'effect_size_type':{'label':'Effect size type','tip':'Select effect size type of your uploaded GWAS file.'},
    'effect_size':{'label':'Effect size column','tip':'Select effect size column of your uploaded GWAS file.'},
    'se':{'label':'Standard error column','tip':'Select standard error (SE) column of your uploaded GWAS file.'},
    'filter_eqtl_p':{'label':'P-value threshold for eQTL','tip':'Specify the p-value threshold of eQTLs; only eQTLs with a p-value lower than the threshold will be considered.'},
    'ld_pruning_mr':{'label':'LD coefficient threshold','tip':'Specify the threshold of LD coefficient when pruning variants; for each gene or transcript, eQTLs with LD coefficients higher than the threshold will be pruned.'},
    'emic_pfm_p':{'label':'P-value threshold for EMIC-PFM','tip':'Specify the p-value threshold to further perform an EMIC pleiotropy fine-mapping (EMIC-PFM) analysis; if the EMIC p-value of a gene is lower than the threshold, an EMIC-PFM will be performed to control the false-positive caused by pleiotropy.'},
    'emic_plot_p':{'label':'P-value threshold for plotting','tip':'specify the p-value threshold for plotting a scatter plot; genes with an EMIC p-value lower than the threshold will be plotted.'},
    'permutation':{'label':'Correct P-values','tip':'Perform permutation to correct the multiple testing for associated tissues and cell types. If this option is turned on, the program will take several hours to run.'}


};


// WEBPACK FOOTER //
// ./src/bus.js